export const TestIds = {
  login: {
    emailTxt: 'login-email',
    loginCodeTxt: 'login-login-code',
    loginBtn: 'login-login-button',
    editEmailAddressLnk: 'login-edit-email-address',
    contactSupportLnk: 'login-contact-support',
    createAccountBtn: 'login-create-account-button',
  },
  signup: {
    editEmailLnk: 'signup-edit-email',
    emailInput: 'signup-email-input',
    registrationBtn: 'signup-registration-button',
    existingAccountBtn: 'signup-existing-email-account-button',
    firstNameInput: 'signup-first-name-input',
    lastNameInput: 'signup-last-name-input',
    companyNameInput: 'signup-company-name-input',
    tradeInput: 'signup-trade-input',
    completeRegistrationBtn: 'signup-complete-registration-button',
    snBackBtn: 'back-to-SN-button',
  },
  onboarding: {
    enrollBtn: 'onboarding-enroll',
    roleAtCompanyLst: 'onboarding-role-at-company',
    nextBtn: 'onboarding-next',
    previousLnk: 'onboarding-previous-link',
    homedepotShopTitle: 'onboarding-hd-shop-title',
    homedepotShopYesBtn: 'onboarding-hd-shop-option-yes-btn',
    homedepotShopNoBtn: 'onboarding-hd-shop-option-no-btn',
    homedepotShopNextBtn: 'onboarding-hd-shop-next-btn',
    homedepotXtraYesBtn: 'onboarding-hd-xtra-option-yes-btn',
    homedepotXtraNoBtn: 'onboarding-hd-xtra-option-no-btn',
    homedepotXtraUnsureBtn: 'onboarding-hd-xtra-option-unsure-btn',
    homedepotXtraLaterLnk: 'onboarding-hd-xtra-later-lnk',
    homedepotLaunchBtn: 'onboarding-hd-launch-btn',
    homedepotLinkedMyAccountBtn: 'onboarding-hd-linked-my-account-btn',
    homedepotDoneBtn: 'onboarding-hd-done-btn',
    homedepotShowAgainLnk: 'onboarding-hd-no-show-again-lnk',
    homedepotEmailAdressTxt: 'onboarding-hd-email-address-txt',
    homedepotCompleteEnrollmentBtn: 'onboarding-hd-complete-enrollment-btn',
    homedepotMobileCompleteSetupBtn: 'onboarding-hd-mobile-complete-setup-btn',
  },
  contentFeed: {
    contentFeedSection: 'content-feed-section',
    // Suffixed with the filter's tag, e.g. content-filter-tab-Featured.
    filterTabPrefix: 'content-filter-tab',
    contentCard: 'content-card',
    viewMoreBtn: 'content-feed-view-more',
    savedBtn: 'content-feed-saved-btn',
    savedBackBtn: 'content-feed-saved-back-btn',
    savedEmptyStateCtaBtn: 'content-feed-saved-empty-state-cta-btn',
    showMoreLikeThisBtn: 'content-show-more-like-this-btn',
    showLessLikeThisBtn: 'content-show-less-like-this-btn',
    lockedOverlay: 'content-locked-overlay',
    paidMembershipLabel: 'content-paid-membership-label',
    upgradeBtn: 'content-upgrade-btn',
    contactSalesBtn: 'content-contact-sales-btn',
    contactSalesDialogCloseBtn: 'content-contact-sales-dialog-close-btn',
    contactSalesDialogDescription: 'content-contact-sales-dialog-description',
    contactSalesConfirmBtn: 'content-contact-sales-confirm-btn',
    contactSalesConfirmationMsg: 'content-contact-sales-confirmation-msg',
  },
  welcomeModal: {
    welcomePageBtn: 'welcome-modal-welcome-page-btn',
    partnerSelectPageBtn: 'welcome-modal-partner-select-page-btn',
    homeDepotPartnerSelector: 'welcome-modal-home-depot-partner-selector',
    hdSupplyPartnerSelector: 'welcome-modal-hd-supply-partner-selector',
    interestPageBtn: 'welcome-modal-interest-page-btn',
  },
  followTopics: {
    btnPrefix: 'follow-topics',
    hiringBtn: 'follow-topics-hiring-btn',
    pricingBtn: 'follow-topics-pricing-btn',
    leadGenerationBtn: 'follow-topics-lead-generation-btn',
    technologyBtn: 'follow-topics-technology-btn',
    marketingBtn: 'follow-topics-marketing-btn',
    leadershipBtn: 'follow-topics-leadership-btn',
    financesTaxesBtn: 'follow-topics-finances-and-taxes-btn',
  },
  businessGoals: {
    scaleMyBusinessBtn: 'business-goals-scale-my-business-btn',
    betterWorkLifeBalanceBtn: 'business-goals-better-work-life-balance-btn',
    controlCashFlowBtn: 'business-goals-control-cash-flow-btn',
  },
  contentArticleView: {
    backBtn: 'content-article-view-back-btn',
    saveBtn: 'content-article-view-save-btn',
    shareBtn: 'content-article-view-share-btn',
    contentAuthorName: 'content-article-view-author-name',
    contentTitle: 'content-article-view-title',
    contentPublishedDate: 'content-article-view-published-date',
    contentTopic: 'content-article-view-topic',
    contentBody: 'content-article-view-body',
    highlightsSection: 'content-article-view-highlights-section',
    highlightsTitle: 'content-article-view-highlights-title',
    highlightsItem: 'content-article-view-highlights-item',
  },
  trainingPage: {
    heading: 'training-page-heading',
    iframe: 'training-page-iframe',
    error: 'training-page-error',
    skeleton: 'training-page-skeleton',
  },
  designServicesPage: {
    heading: 'design-services-page-heading',
    iframe: 'design-services-page-iframe',
    error: 'design-services-page-error',
    skeleton: 'design-services-page-skeleton',
  },
  advisoryBoardsPage: {
    heading: 'advisory-boards-page-heading',
    iframe: 'advisory-boards-page-iframe',
    error: 'advisory-boards-page-error',
    skeleton: 'advisory-boards-page-skeleton',
  },
  walletPage: {
    walletMenuItemSecondary: 'wallet-menu-item-secondary',
    rewardsBalanceCard: 'wallet-rewards-balance-card',
    rewardsBalanceValue: 'wallet-rewards-balance-value',
    rewardsBalanceLastUpdate: 'wallet-rewards-balance-last-update-value',
    rewardsBalanceBtn: 'wallet-rewards-balance-button',
    smallCardRewards: 'wallet-small-card-rewards',
    smallCardRewardsContent: 'wallet-small-card-rewards-content',
    smallCardRewardsSubtitle: 'wallet-small-card-rewards-subtitle',
    smallCardPayout: 'wallet-small-card-payout',
    smallCardPayoutContent: 'wallet-small-card-payout-content',
    smallCardPayoutSubtitle: 'wallet-small-card-payout-subtitle',
    transactionList: 'wallet-transaction-list',
    transactionListItem: 'wallet-transaction-list-item',
    transactionListPartner: 'wallet-transaction-list-item-partner',
    transactionListCreatedAt: 'wallet-transaction-list-item-createdAt',
    transactionListAmount: 'wallet-transaction-list-item-amount',
    transactionListBtn: 'wallet-transaction-list-button',
    transactionFullListPartner: 'transaction-list-full-item-partner',
    transactionFullListAmount: 'transaction-list-full-item-amount',
    transactionFullListCreatedAt: 'transaction-list-full-item-createdAt',
    partnerList: 'wallet-partner-list',
    partnerListItem: 'wallet-partner-list-item',
    partnerListPartner: 'wallet-partner-list-item-name',
    partnerListCreatedAt: 'wallet-partner-list-item-id',
    partnerListBtn: 'wallet-partner-list-button',
    payoutSettings: 'wallet-payout-settings',
    payoutConnected: 'wallet-payout-connected',
    payoutNotConnected: 'wallet-payout-not-connected',
    payoutSettingsDialog: 'wallet-payout-settings-dialog',
    historicalRebateData: 'wallet-historical-rebate-data',
  },
  managePayoutSettings: {
    dialogTitle: 'wallet-payout-settings-dialog-title',
    connectBtn: 'wallet-payout-settings-connect-btn',
    confirmActiveBtn: 'wallet-payout-settings-confirm-active-btn',
    confirmDeleteBtn: 'wallet-payout-settings-confirm-delete-btn',
    goBackBtn: 'wallet-payout-settings-go-back-btn',
    activeCheckbox: 'wallet-payout-settings-active-checkbox',
  },
  bankAccountForm: {
    businessNameTxt: 'payout-settings-bank-account-business-name-txt',
    accountTypeTxt: 'payout-settings-bank-account-type-txt',
    routingNumberTxt: 'payout-settings-bank-account-routing-number-txt',
    accountNumberTxt: 'payout-settings-bank-account-number-txt',
    businessAddressTxt: 'payout-settings-bank-account-business-address-txt',
    connectBtn: 'payout-settings-bank-account-connect-btn',
  },
  paypalVerification: {
    verificationCompleteDialog: {
      paypalEmail: 'paypal-verification-complete-dialog-paypal-email',
      unlinkPaypalLink: 'wallet-paypal-verification-unlink-paypal-link',
      unlinkPaypalMsg: 'wallet-paypal-verification-unlink-paypal-msg',
    },
    unlink: {
      unlinkBtn: 'wallet-paypal-verification-unlink-btn',
      cancelLink: 'wallet-paypal-verification-unlink-cancel-link',
      description: 'wallet-paypal-verification-unlink-description',
      title: 'wallet-paypal-verification-unlink-title',
    },
    connectWithPaypal: {
      connectBtn: 'wallet-paypal-verification-connect-btn',
      acknowledgeCheckbox: 'wallet-paypal-verification-acknowledge-checkbox',
    },
  },
  partnersPage: {
    allPartnersTab: 'partners-all-partners-tab',
    yourPartnersTab: 'partners-your-partners-tab',
    searchInput: 'partners-search-input',
    noResultsMessage: 'partners-no-results-message',
    yourPartnersEmptyState: 'partners-your-partners-empty-state',
    yourPartnersEmptyCta: 'partners-your-partners-empty-cta',
    requiredFormsButton: 'partners-required-forms-button',
    rebateAnalysisButton: 'partners-rebate-analysis-button',
    purchaseReportingButton: 'partners-purchase-reporting-button',
    homedepotCard: 'partners-homedepot',
    homedepotName: 'partners-homedepot-name',
    homedepotEnrollmentInfo: 'partners-homedepot-enrollment-info',
    homedepotLearnMore: 'partners-homedepot-learn-more',
    homedepotBenefit: 'partners-homedepot-benefit',
    homedepotAdditionalBenefit: 'partners-homedepot-additional-benefit',
    hdSupplyCard: 'partners-hdsupply',
    hdSupplyName: 'partners-hdsupply-name',
    hdsupplyEnrollmentInfo: 'partners-hdsupply-enrollment-info',
    hdsupplyLearnMore: 'partners-hdsupply-learn-more',
    hdsupplyBenefit: 'partners-hdsupply-benefit',
    hdsupplyAdditionalBenefit: 'partners-hdsupply-additional-benefit',
    behrCard: 'partners-behr',
    behrName: 'partners-behr-name',
    behrEnrollmentInfo: 'partners-behr-enrollment-info',
    behrLearnMore: 'partners-behr-learn-more',
    behrBenefit: 'partners-behr-benefit',
    behrAdditionalBenefit: 'partners-behr-additional-benefit',
    kilzCard: 'partners-kilz',
    kilzName: 'partners-kilz-name',
    kilzEnrollmentInfo: 'partners-kilz-enrollment-info',
    kilzLearnMore: 'partners-kilz-learn-more',
    kilzBenefit: 'partners-kilz-benefit',
    kilzAdditionalBenefit: 'partners-kilz-additional-benefit',
    capitalWrapsCard: 'partners-capitalwraps',
    capitalWrapsName: 'partners-capitalwraps-name',
    capitalWrapsEnrollmentInfo: 'partners-capitalwraps-enrollment-info',
    capitalWrapsLearnMore: 'partners-capitalwraps-learn-more',
    capitalWrapsBenefit: 'partners-capitalwraps-benefit',
    capitalWrapsAdditionalBenefit: 'partners-capitalwraps-additional-benefit',
    spartanCard: 'partners-spartantool',
    spartanName: 'partners-spartantool-name',
    spartanEnrollmentInfo: 'partners-spartantool-enrollment-info',
    spartanLearnMore: 'partners-spartantool-learn-more',
    spartanBenefit: 'partners-spartantool-benefit',
    spartanAdditionalBenefit: 'partners-spartantool-additional-benefit',
    winsupplyCard: 'partners-winsupply',
    winsupplyName: 'partners-winsupply-name',
    winsupplyEnrollmentInfo: 'partners-winsupply-enrollment-info',
    winsupplyLearnMore: 'partners-winsupply-learn-more',
    winsupplyBenefit: 'partners-winsupply-benefit',
    winsupplyAdditionalBenefit: 'partners-winsupply-additional-benefit',
    weSupplyTradesCard: 'partners-wesupplytrades',
    weSupplyTradesName: 'partners-wesupplytrades-name',
    weSupplyTradesEnrollmentInfo: 'partners-wesupplytrades-enrollment-info',
    weSupplyTradesLearnMore: 'partners-wesupplytrades-learn-more',
    weSupplyTradesBenefit: 'partners-wesupplytrades-benefit',
    weSupplyTradesAdditionalBenefit: 'partners-wesupplytrades-additional-benefit',
    postcardManiaCard: 'partners-postcardmania',
    postcardManiaName: 'partners-postcardmania-name',
    postcardManiaEnrollmentInfo: 'partners-postcardmania-enrollment-info',
    postcardManiaBenefit: 'partners-postcardmania-benefit',
    postcardManiaLearnMore: 'partners-postcardmania-learn-more',
    postcardManiaAdditionalBenefit: 'partners-postcardmania-additional-benefit',
    coastCard: 'partners-coast',
    coastName: 'partners-coast-name',
    coastEnrollmentInfo: 'partners-coast-enrollment-info',
    coastBenefit: 'partners-coast-benefit',
    coastLearnMore: 'partners-coast-learn-more',
    sunbeltRentalsCard: 'partners-sunbeltrentals',
    sunbeltRentalsName: 'partners-sunbeltrentals-name',
    sunbeltRentalsEnrollmentInfo: 'partners-sunbeltrentals-enrollment-info',
    sunbeltRentalsBenefit: 'partners-sunbeltrentals-benefit',
    sunbeltRentalsLearnMore: 'partners-sunbeltrentals-learn-more',
    sunbeltRentalsAdditionalBenefit: 'partners-sunbeltrentals-additional-benefit',
    everConnectCard: 'partners-everconnect',
    everConnectName: 'partners-everconnect-name',
    everConnectEnrollmentInfo: 'partners-everconnect-enrollment-info',
    everConnectBenefit: 'partners-everconnect-benefit',
    everConnectLearnMore: 'partners-everconnect-learn-more',
    everConnectAdditionalBenefit: 'partners-everconnect-additional-benefit',
    rinnaiCard: 'partners-rinnai',
    rinnaiName: 'partners-rinnai-name',
    rinnaiEnrollmentInfo: 'partners-rinnai-enrollment-info',
    rinnaiLearnMore: 'partners-rinnai-learn-more',
    rinnaiBenefit: 'partners-rinnai-benefit',
    rinnaiAdditionalBenefit: 'partners-rinnai-additional-benefit',
    companyProfile: {
      title: 'partners-company-profile-title',
      getStartedBtn: 'partners-company-profile-get-started-btn',
      signUpForm: {
        submitBtn: 'partners-company-profile-form-submit-btn',
        closeBtn: 'partners-company-profile-form-close-btn',
      },
    },
  },
  partnerDetailsPage: {
    completeRequiredFormBtn: 'partner-details-complete-required-form-btn',
    markAsCompleteBtn: 'partner-details-mark-as-complete-btn',
    earningRewardsBadge: 'partner-details-earning-rewards-badge',
    unlinkLnk: 'partner-details-unlink-lnk',
    // Suffixed with the CompanyPartnerEnrollmentStatus value, e.g.
    // `partner-enrollment-status-in_progress`. See PartnerEnrollmentStatusBadge.
    enrollmentStatusBadgePrefix: 'partner-enrollment-status',
    upgradeNowBtn: 'partner-details-upgrade-now-btn',
    contactSalesBtn: 'partner-details-contact-sales-btn',
    rebateMatrixCurrentTierHeader: 'partner-details-rebate-matrix-current-tier-header',
    rebateMatrixNextTierHeader: 'partner-details-rebate-matrix-next-tier-header',
    rebateMatrixUpgradeNowBtn: 'partner-details-rebate-matrix-upgrade-now-btn',
    rebateMatrixContactSalesBtn: 'partner-details-rebate-matrix-contact-sales-btn',
    contactSalesConfirmBtn: 'partner-details-contact-sales-confirm-btn',
    contactSalesDialogCloseBtn: 'partner-details-contact-sales-dialog-close-btn',
    contactSalesConfirmationMsg: 'partner-details-contact-sales-confirmation-msg',
    contactSalesDialogDescription: 'partner-details-contact-sales-dialog-description',
    contactSalesDialogPartnerName: 'partner-details-contact-sales-dialog-partner-name',
    imInterestedBtn: 'partner-details-im-interested-btn',
    imInterestedConfirmBtn: 'partner-details-im-interested-confirm-btn',
    imInterestedDialogCloseBtn: 'partner-details-im-interested-dialog-close-btn',
    // The per-distributor variant is suffixed with the partner id, e.g.
    // `partner-enrollment-shop-now-<uuid>`. See PartnerOverviewSection.
    // The Home Depot panel suffixes the partner code instead:
    // `partner-enrollment-shop-now-hd`. See HDEnrollmentStatusPanel.
    shopNowBtnPrefix: 'partner-enrollment-shop-now',
  },
  individualPartnersPage: {
    homeDepotPage: 'partners-individual-homeDepot',
    homeDepotTitle: 'partners-individual-homeDepot-title',
    homeDepotWebsiteBtn: 'partners-individual-homedepot-website-button',
    hdsupplyPage: 'partners-individual-hdsupply',
    hdsupplyTitle: 'partners-individual-hdsupply-title',
    hdSupplyWebsiteBtn: 'partners-individual-hdsupply-website-button',
    capitalWrapsPage: 'partners-individual-capitalwraps',
    capitalWrapsTitle: 'partners-individual-capitalwraps-title',
    capitalWrapsWebsiteBtn: 'partners-individual-capitalwraps-website-button',
    spartanToolPage: 'partners-individual-spartantool',
    spartanToolTitle: 'partners-individual-spartantool-title',
    spartanToolWebsiteBtn: 'partners-individual-spartantool-website-button',
    winsupplyPage: 'partners-individual-winsupply',
    winsupplyTitle: 'partners-individual-winsupply-title',
    winsupplyWebsiteBtn: 'partners-individual-winsupply-website-button',
    weSupplyTradesPage: 'partners-individual-weSupplyTrades',
    weSupplyTradesTitle: 'partners-individual-weSupplyTrades-title',
    weSupplyTradesWebsiteBtn: 'partners-individual-wesupplytrades-website-button',
    sunbeltRentalsPage: 'partners-individual-sunbeltrentals',
    sunbeltRentalsTitle: 'partners-individual-sunbeltrentals-title',
    sunbeltRentalsWebsiteBtn: 'partners-individual-sunbeltrentals-website-button',
    coastPage: 'partners-individual-coast',
    coastTitle: 'partners-individual-coast-title',
    coastWebsiteBtn: 'partners-individual-coast-website-button',
    everConnectPage: 'partners-individual-everconnect',
    everConnectTitle: 'partners-individual-everconnect-title',
    everConnectWebsiteBtn: 'partners-individual-everconnect-website-button',
    rinnaiPage: 'partners-individual-rinnai',
    rinnaiTitle: 'partners-individual-rinnai-title',
    rinnaiWebsiteBtn: 'partners-individual-rinnai-website-button',
    postcardManiaPage: 'partners-individual-postcardmania',
    postcardManiaTitle: 'partners-individual-postcardmania-title',
    postcardManiaWebsiteBtn: 'partners-individual-postcardmania-website-button',
  },
  accountSettingsPage: {
    saveMemberInfoBtn: 'account-settings-save-member-info-btn',
    saveCompanyInfoBtn: 'account-settings-save-company-info-btn',
    firstNameTxt: 'account-settings-firstName-txt',
    lastNameTxt: 'account-settings-lastName-txt',
    emailTxt: 'account-settings-email-txt',
    phoneTxt: 'account-settings-phone-txt',
    companyNameTxt: 'account-settings-company-name-txt',
    roleAtCompanyTxt: 'account-settings-role-at-company-txt',
    companyAddressTxt: 'account-settings-company-address-txt',
    companyEmailTxt: 'account-settings-company-email-txt',
    companyPhoneTxt: 'account-settings-company-phone-txt',
    companyWebsiteTxt: 'account-settings-company-website-txt',
    companyVehicleTxt: 'account-settings-company-vehicle-txt',
  },
  accountPreferencesPage: {
    updateBtn: 'account-preferences-update-btn',
    addAdditionalTradeLnk: 'account-preferences-add-additional-lnk',
    skeleton: 'account-preferences-skeleton',
  },
  accountMembershipsPage: {
    heading: 'account-memberships-heading',
    confetti: 'account-memberships-confetti',
  },
  upgradeModal: {
    dialog: 'upgrade-modal-dialog',
    title: 'upgrade-modal-title',
    closeButton: 'upgrade-modal-close-button',
    cardholderNameInput: 'upgrade-modal-cardholder-name-input',
    cardNumberInput: 'upgrade-modal-card-number-input',
    expiryInput: 'upgrade-modal-expiry-input',
    cvvInput: 'upgrade-modal-cvv-input',
    zipCodeInput: 'upgrade-modal-zip-code-input',
    promoCodeInput: 'upgrade-modal-promo-code-input',
    promoCodeError: 'upgrade-modal-promo-code-error',
    amount: 'upgrade-modal-amount',
    termsCheckbox: 'upgrade-modal-terms-checkbox',
    submitButton: 'upgrade-modal-submit-button',
    errorMessage: 'upgrade-modal-error-message',
  },
  successModal: {
    dialog: 'success-modal-dialog',
    title: 'success-modal-title',
    closeButton: 'success-modal-close-button',
    bookOnboardingButton: 'success-modal-book-onboarding-button',
  },
  onboardingBanner: {
    container: 'onboarding-banner-container',
    scheduleButton: 'onboarding-banner-schedule-button',
    dismissButton: 'onboarding-banner-dismiss-button',
  },
  rewardsPage: {
    signUpForm: {
      fullnameLbl: 'rewards-common-signup-form-fullname',
      firstNameTxt: 'rewards-common-signup-form-firstName-txt',
      lastNameTxt: 'rewards-common-signup-form-lastName-txt',
      businessNameTxt: 'rewards-common-signup-form-businessName-txt',
      companyEmailTxt: 'rewards-common-signup-form-companyEmail-txt',
      companyPhoneTxt: 'rewards-common-signup-form-companyPhone-txt',
      websiteTxt: 'rewards-common-signup-form-website-txt',
      closeBtn: 'rewards-common-signUp-form-close-btn',
      partnerLinkBtn: 'rewards-common-signUp-form-partner-link-btn',
      unlinkBtn: 'rewards-common-signUp-form-unlink-btn',
    },
    capitalWraps: {
      signUpForm: {
        submitBtn: 'rewards-capitalWraps-signUp-form-submit-btn',
        closeBtn: 'rewards-capitalWraps-signUp-form-close-btn',
      },
      learnMoreBtn: 'rewards-capitalWraps-learn-more-btn',
    },
    spartanTool: {
      signUpForm: {
        submitBtn: 'rewards-spartanTool-signUp-form-submit-btn',
        closeBtn: 'rewards-spartanTool-signUp-form-close-btn',
      },
      signUpBtn: 'rewards-spartanTool-sign-up-btn',
    },
    winsupply: {
      signUpOrExistingAccForm: {
        proceedEnrollmentBtn: 'rewards-winsupply-signUpOrExistingAcc-form-proceedEnrollment-btn',
        existingAccountBtn: 'rewards-winsupply-signUpOrExistingAcc-form-existingAccount-btn',

      },
      existingAccForm: {
        submitBtn: 'rewards-winsupply-existingAcc-form-submit-btn',
        goBackBtn: 'rewards-winsupply-existingAcc-form-goBack-btn',
        noAccountNumberCheckbox: 'rewards-winsupply-existingAcc-form-dontHaveAccount-checkbox',
      },
      signUpForm: {
        submitBtn: 'rewards-winsupply-signUp-form-submit-btn',
        closeBtn: 'rewards-winsupply-signUp-form-close-btn',
      },
    },
    hdSupply: {
      signUpOrExistingAccForm: {
        proceedEnrollmentBtn: 'rewards-hdsupply-signUpOrExistingAcc-form-proceedEnrollment-btn',
        existingAccountBtn: 'rewards-hdsupply-signUpOrExistingAcc-form-existingAccount-btn',

      },
      existingAccForm: {
        submitBtn: 'rewards-hdsupply-existingAcc-form-submit-btn',
        goBackBtn: 'rewards-hdsupply-existingAcc-form-goBack-btn',
        noAccountNumberCheckbox: 'rewards-hdsupply-existingAcc-form-dontHaveAccount-checkbox',
      },
      signUpForm: {
        submitBtn: 'rewards-hdsupply-signUp-form-submit-btn',
        closeBtn: 'rewards-hdsupply-signUp-form-close-btn',
      },
    },
    weSupplyTrades: {
      signUpForm: {
        submitBtn: 'rewards-weSupplyTrades-signUp-form-submit-btn',
        closeBtn: 'rewards-weSupplyTrades-signUp-form-close-btn',
      },
    },
    coast: {
      signUpForm: {
        submitBtn: 'rewards-coast-signUp-form-submit-btn',
        closeBtn: 'rewards-coast-signUp-form-close-btn',
      },
    },
    rinnai: {
      signUpForm: {
        closeBtn: 'rewards-common-signUp-form-close-btn-rinnai',
      },
    },
    sunbeltRentals: {
      signUpOrExistingAccForm: {
        proceedEnrollmentBtn: 'rewards-sunbelt-rentals-signUpOrExistingAcc-form-proceedEnrollment-btn',
        existingAccountBtn: 'rewards-sunbelt-rentals-signUpOrExistingAcc-form-existingAccount-btn',

      },
      signUpForm: {
        submitBtn: 'rewards-sunbelt-rentals-signUp-form-submit-btn',
        closeBtn: 'rewards-sunbelt-rentals-signUp-form-close-btn',
      },
      existingAccForm: {
        submitBtn: 'rewards-sunbelt-rentals-existingAcc-form-submit-btn',
        goBackBtn: 'rewards-sunbelt-rentals-existingAcc-form-goBack-btn',
        noAccountNumberCheckbox: 'rewards-sunbelt-rentals-existingAcc-form-dontHaveAccount-checkbox',
        makeEdgeExclusiveCheckbox: 'rewards-sunbelt-rentals-existingAcc-form-makeEdgeExclusive-checkbox',
      },

    },
    everConnect: {
      signUpForm: {
        submitBtn: 'rewards-everConnect-signUp-form-submit-btn',
        closeBtn: 'rewards-common-signUp-form-close-btn-everconnect',
      },
    },
    noFormModal: {
      submitBtn: 'rewards-signUp-submit-btn',
    },
  },
  joist: {
    coverFrame: 'joist-cover-frame',
    logo: 'joist-logo',
    reviewsLink: 'joist-reviews-link',
    reviewsCard: 'joist-reviews-card',
  },
  checklist: {
    btn: 'home-checklist-btn',
    step1: 'home-checklist-step1',
    step2: 'home-checklist-step2',
    step3: 'home-checklist-step3',
  },
  topNavigation: {
    header: 'top-nav-header',
    navItemPrefix: 'top-nav-item',
    moreBtn: 'top-nav-more-button',
    moreMenu: 'top-nav-more-menu',
    moreItemPrefix: 'top-nav-more-item',
    accountBtn: 'top-nav-account-button',
    accountMenu: 'top-nav-account-menu',
    accountItemPrefix: 'top-nav-account-item',
    upgradeLnk: 'top-nav-account-upgrade-link',
    hamburgerBtn: 'top-nav-hamburger-button',
    drawer: 'top-nav-drawer',
    drawerItemPrefix: 'top-nav-drawer-item',
  },
  // Only rendered by tests, e.g. to read the router location.
  testUtils: {
    locationProbe: 'test-location-probe',
    // Suffixed with the stubbed component's name, e.g. test-stub-HomePage.
    stubPrefix: 'test-stub',
  },
  homePage: {
    heading: 'home-page-heading',
    coachBar: 'home-page-coach-bar',
    coachInput: 'home-page-coach-input',
    coachSendBtn: 'home-page-coach-send-button',
    highlights: 'home-page-highlights',
    highlightCard: 'home-page-highlight-card',
    viewMoreBtn: 'home-page-view-more-button',
    upcoming: 'home-page-upcoming',
    upcomingItem: 'home-page-upcoming-item',
    upcomingLink: 'home-page-upcoming-link',
  },
  coach: {
    chatContainer: 'coach-chat-container',
    message: 'coach-message',
    messageBubble: 'coach-message-bubble',
    statusIndicator: 'coach-status-indicator',
    errorText: 'coach-error-text',
    messageInput: 'coach-message-input',
    sendBtn: 'coach-send-button',
    heading: 'coach-heading',
    subtitle: 'coach-subtitle',
    starterCard: 'coach-starter-card',
    personalCoachingTab: 'coach-live-coaching-tab',
    aiCoachTab: 'coach-ai-coach-tab',
    businessProfileTab: 'coach-business-profile-tab',
    quickPrompt: 'coach-quick-prompt',
    confidentialityLink: 'coach-confidentiality-link',
    feedbackBar: 'coach-feedback-bar',
    feedbackLabel: 'coach-feedback-label',
    feedbackThumbsUpBtn: 'coach-feedback-thumbs-up-button',
    feedbackThumbsDownBtn: 'coach-feedback-thumbs-down-button',
    feedbackCommentInput: 'coach-feedback-comment-input',
    feedbackSubmitBtn: 'coach-feedback-submit-button',
    feedbackCancelBtn: 'coach-feedback-cancel-button',
    liveCoachingContainer: 'live-coaching-container',
    oneOnOneCardDecoration: 'live-coaching-one-on-one-card-decoration',
    oneOnOneCardDecorationCircle: 'live-coaching-one-on-one-card-decoration-circle',
    scheduleConsultButton: 'live-coaching-schedule-consult-button',
    tierCtaButton: 'live-coaching-tier-cta-button',
    comingSoonCard: 'coach-coming-soon-card',
    comingSoonJoinBetaBtn: 'coach-coming-soon-join-beta-button',
    comingSoonNotifyBtn: 'coach-coming-soon-notify-button',
    comingSoonConfirmModal: 'coach-coming-soon-confirm-modal',
    comingSoonConfirmModalBtn: 'coach-coming-soon-confirm-modal-button',
    conversationTitle: 'coach-conversation-title',
    historyLoading: 'coach-history-conversation-loading',
    history: {
      container: 'coach-history-container',
      scrollArea: 'coach-history-scroll-area',
      heading: 'coach-history-heading',
      newChatButton: 'coach-history-new-chat-button',
      newChatItem: 'coach-history-new-chat-item',
      groupLabel: 'coach-history-group-label',
      item: 'coach-history-item',
      dialog: 'coach-history-dialog',
      openDialogButton: 'coach-history-open-dialog-button',
      closeDialogButton: 'coach-history-close-dialog-button',
      loading: 'coach-history-loading',
      error: 'coach-history-error',
      retryButton: 'coach-history-retry-button',
      empty: 'coach-history-empty',
      menuButton: 'coach-history-menu-button',
      menu: 'coach-history-menu',
      renameMenuItem: 'coach-history-rename-menu-item',
      deleteMenuItem: 'coach-history-delete-menu-item',
      renameInput: 'coach-history-rename-input',
      renameSaveButton: 'coach-history-rename-save-button',
      actionError: 'coach-history-action-error',
      deleteDialog: 'coach-history-delete-dialog',
      deleteDialogCloseButton: 'coach-history-delete-dialog-close-button',
      deleteDialogCancelButton: 'coach-history-delete-dialog-cancel-button',
      deleteDialogConfirmButton: 'coach-history-delete-dialog-confirm-button',
      deleteDialogError: 'coach-history-delete-dialog-error',
    },
    businessProfile: {
      container: 'coach-business-profile-container',
      title: 'coach-business-profile-title',
      progress: 'coach-business-profile-progress',
      summaryPrefix: 'coach-business-profile-summary',
      changePrefix: 'coach-business-profile-change',
      tradeSelect: 'coach-business-profile-trade-select',
      customTradeInput: 'coach-business-profile-custom-trade-input',
      revenueChoicePrefix: 'coach-business-profile-revenue-choice',
      workforceChoicePrefix: 'coach-business-profile-workforce-choice',
      stageChoicePrefix: 'coach-business-profile-stage-choice',
      fieldCount: 'coach-business-profile-field-count',
      fieldDecrement: 'coach-business-profile-field-decrement',
      fieldIncrement: 'coach-business-profile-field-increment',
      officeCount: 'coach-business-profile-office-count',
      officeDecrement: 'coach-business-profile-office-decrement',
      officeIncrement: 'coach-business-profile-office-increment',
      saveButton: 'coach-business-profile-save-button',
      finishLaterButton: 'coach-business-profile-finish-later-button',
      noChangesButton: 'coach-business-profile-no-changes-button',
      banner: 'coach-business-profile-banner',
      bannerAction: 'coach-business-profile-banner-action',
    },
  },
};
